<template>
  <div class="ml-2 my-2 xl:m-0">
    <div class="flex justify-between items-center">
      <span>
        <p>{{ $t("lang.msg.daysIn") }}</p>
        <p class="text-gray-900 font-semibold">{{ $t("lang.msg.management") }}</p>
      </span>
      <div
        class="bg-white w-16 h-16 ml-2 flex justify-center items-center"
        :class="{ border: index % 2 != 0 }"
      >
        <span class="text-3xl font-bold">{{ getManagementDays(activationDate) }}</span>
      </div>
    </div>
    <div class="flex justify-between items-center mt-4"  v-if="!isDelivered">
      <span>
        <p>{{ $t("lang.msg.daysTo") }}</p>
        <p class="text-gray-900 font-semibold">{{ $t("lang.msg.deliver") }}</p>
      </span>
      <div
        class="flex justify-center items-center w-16 h-16 bg-white ml-2"
        :class="{
          'border': index % 2 != 0,
          'text-verde': daysToDeliver.daysRemainingPercent >= 25 && daysToDeliver.daysRemaining > 0,
          'text-rojo': daysToDeliver.daysRemainingPercent < 25 || daysToDeliver.daysRemaining < 0,
          'parpadeo': daysToDeliver.daysRemainingPercent < 10 || daysToDeliver.daysRemaining < 0
        }"
      >
        <span class="text-3xl font-bold" v-html="daysToDeliver.daysRemaining" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlanningDays",
  props: {
    deliveryDate: {
      type: String,
      default: ""
    },
    activationDate: {
      type: String,
      default: ""
    },
    index: {
      type: [Number, String],
      default: 1
    },
    endDate: {
      type: String,
      default: ""
    },
    isFinished: {
      type: Boolean,
      default: false
    },
      isDelivered:{
          type: Boolean,
          default: false
    }
  },
  computed: {
    daysToDeliver() {
      return this.getDaysToDeliver(this.deliveryDate, this.activationDate);
    }
  },
  methods: {
    /**
     * Return the day difference between dates. Both parameters are MomentJS objects.
     */
    getDayDifference(lateDate, earlyDate) {
      return lateDate.diff(earlyDate.startOf("day"), "days");
    },
    getManagementDays(activationDate) {
      let lastDate = this.isFinished ? this.$moment(this.endDate) : this.$moment();

      let days = this.getDayDifference(
        lastDate,
        this.$moment(activationDate)
      );

      return days < 999 ? days : "...";
    },
    /**
     * It will return 2 values:
     * 1) The day difference FROM today TO deliveryDate. (Days to deliver)
     * 2) The % of days completed FROM ActivationDate TO deliveryDate.
     */
    getDaysToDeliver(deliveryDate, activationDate) {
      let lastDate = this.isFinished ? this.$moment(this.endDate) : this.$moment();

      // Days remaining from today to deliveryDate.
      let daysRemaining = this.getDayDifference(
        this.$moment(deliveryDate),
        lastDate
      );

      // Full interval of days to deliver since the activationDate.
      let daysToDeliver = this.getDayDifference(
        this.$moment(deliveryDate),
        this.$moment(activationDate)
      );

      return {
        daysRemaining: daysRemaining > -999 ? daysRemaining : "...",
        daysRemainingPercent: (daysRemaining / daysToDeliver) * 100
      };
    }
  }
};
</script>
